{
  "version": 1,
  "asset_id": "7c734883-4493-4fe2-87f2-5ce2fc1f1194",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/7c734883-4493-4fe2-87f2-5ce2fc1f1194/hernando-galvalume-metal-roof-aerial-1320w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/7c734883-4493-4fe2-87f2-5ce2fc1f1194/hernando-galvalume-metal-roof-aerial-1320w.avif",
  "original_filename": "hernando-galvalume-metal-roof-aerial-1320w.avif",
  "size": 82213,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:41Z"
}
